<template>
  <div class="pointShopDetail">
    <van-nav-bar
      title="商品详情"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="main">
      <div class="PointBanner">
        <div class="indexswipers">
          <a class="swiper-img">
            <img :src="point_info.img" alt="">
          </a>
          <!-- <swiper :options="swiperPoint" ref="PointSwiper" id="PointSwiper">
              <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">
                  <a :href= "slide.url" class="swiper-img">
                      <img :src= "slide.image" alt="">
                  </a>
              </swiper-slide>
              <div class="swiper-pagination" id="PointPagnation" slot="pagination"></div>
          </swiper> -->
        </div>
      </div>
      <div class="m-box12">
        <div class="txt">
          <div class="wp2">
            <h4>{{point_info.title}}</h4>
            <!-- <em>￥90</em> -->
            <p>{{point_info.money}}积分</p>
            <div class="info">
              剩余：{{point_info.count}}
              <div class="sp">
                <span class="sp1">运费：<em>{{point_info.freight}}</em></span>
                <span class="sp2">销量：{{point_info.order_count}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="imgtxt">
          <img :src="point_info.particulars" alt=""/>
          <!-- <img src="../../assets/images/j-p13.jpg" alt="" />
          <img src="../../assets/images/j-p14.jpg" alt="" /> -->
        </div>
        <div class="buy">
          <a class="a-buy" @click.prevent="addCart">加入购物车</a>
          <div class="r-side">
            可用积分：{{point}}
            <a :style="point < point_info.money || point_info.count == 0 ? 'background:#ccc;' : 'background:#60b0e3;' "
               @click.prevent="Redeem">立即兑换</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
   import Vue from 'vue'
   import {NavBar} from 'vant'

   Vue.use(NavBar)
   import {createAPI, Toast} from 'cube-ui'
   // createAPI(Vue, Toast, ['click'], true)
   // import { locale } from 'moment';
   //  swiperPoint: {
   //   notNextTick: true,
   //   //循环
   //   loop:true,
   //   //设定初始化时slide的索引
   //   initialSlide:0,
   //   //自动播放
   //   autoplay:false,
   //   // autoplay: {
   //   //     delay: 3000,
   //   //     stopOnLastSlide: false,
   //   //     disableOnInteraction: true,
   //   // },
   //   // 设置轮播
   //   effect : 'slide',
   //   //滑动速度
   //   speed:800,
   //   //滑动方向
   //   // direction : 'horizontal',
   //   //小手掌抓取滑动
   //   // grabCursor : true,
   //   //滑动之后回调函数
   //   on: {
   //       slideChangeTransitionEnd: function(){
   //           // console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
   //       },
   //   },
   //   //左右点击
   //   // navigation: {
   //   //     nextEl: '.swiper-button-next',
   //   //     prevEl: '.swiper-button-prev',
   //   // },
   //   //分页器设置
   //   pagination: {
   //     el: '.swiper-pagination',
   //     clickable :true
   //   }
   // },
   // swiperSlides: [
   //   {
   //     image: require('../../assets/images/j-p11.jpg'),
   //     url: ''
   //   },
   //   {
   //     image: require('../../assets/images/j-p11.jpg'),
   //     url: ''
   //   },
   //   {
   //     image: require('../../assets/images/j-p11.jpg'),
   //     url: ''
   //   },
   //   {
   //     image: require('../../assets/images/j-p11.jpg'),
   //     url: ''
   //   },
   // ]
   export default {
      name: 'pointShopDetail',
      data() {
         return {
            commodity_integral_id: this.$route.params.pointshop_id,
            point_info: [],
            user_id: localStorage.getItem('user_id'),
            point: 0,
            storeList: []
         }
      },
      mounted() {
         this.$loading.show()
      },
      created() {
         this.loadPage()
      },
      methods: {
         // 返回
         onClickLeft() {
            this.$router.go(-1)
         },
         loadPage() {
            this.$http.api.pointShopDetail({
               commodity_integral_id: this.commodity_integral_id
            }).then(result => {
               this.$loading.hide()
               this.point_info = {...result}
            })
            this.$http.api.MypointCount({
               user_id: this.user_id
            }).then(result => {
               this.point = result.number
               // console.log(result)2
            })
         },
         // 立即兑换
         Redeem() {
            // console.log(12)
            if (this.point < this.point_info.money || this.point_info.count == 0) {
               return
            } else {
               this.$router.push({name: 'Redeem', params: {'pointId': this.commodity_integral_id}})
            }
         },
         // 加入购物车
         addCart() {
            this.$http.api.addShopCart({
               user_id: this.user_id,
               commodity_integral_id: this.commodity_integral_id
            }).then(result => {
               // console.log(result)
               Toast.$create({
                  txt: "加入成功",
                  type: 'txt',
                  time: 1500
               }).show()
            })
         }
      }
   }
</script>
<style>
  .van-nav-bar .van-icon {
    color: #4B4B4C;
  }

  .van-nav-bar__text {
    color: #E85C00;
  }
</style>
<style lang="less" scoped>
  .pointShopDetail {
    .PointBanner {
      .indexswipers {
        width: 100%;
        //   padding: 0 15px;
        box-sizing: border-box;
        background: #fff;

        #indexSwiper {
          border-radius: 5px;
        }

        //   .swiper-pagination {
        //     position: static;
        //   }
        #PointPagnation /deep/ .swiper-pagination-bullet {
          width: 5px;
          height: 5px;
          margin-right: 5px;
        }

        #PointPagnation /deep/ .swiper-pagination-bullet-active {
          width: 12px;
          height: 5px;
          background: rgba(96, 176, 227, 1);
          border-radius: 6px;
        }

        .indexswipers {
          .swiper-img {
            width: 100%;
            display: inline-block;

            img {
              height: 153px;
              display: inline-block
            }
          }
        }
      }
    }

    .m-box12 .r-side {
      overflow: hidden;
      padding-right: 30px;
      text-align: right;
    }
  }

  .m-box12 .r-side a {
    display: inline-block;
    vertical-align: middle;
    width: 2.48rem;
    height: 0.82667rem;
    line-height: 0.82667rem;
    text-align: center;
    color: #fff;
    background: #60b0e3;
    border-radius: 0.4rem;
    font-size: 0.32rem;
    margin-left: 0.32rem;
  }
</style>


